import { render, staticRenderFns } from "./Erp6Sn.vue?vue&type=template&id=8366ccb8&scoped=true&"
import script from "./Erp6Sn.vue?vue&type=script&lang=js&"
export * from "./Erp6Sn.vue?vue&type=script&lang=js&"
import style0 from "./Erp6Sn.vue?vue&type=style&index=0&id=8366ccb8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8366ccb8",
  null
  
)

export default component.exports